import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import MoreIcon from '../../icons/MoreIcon';
import TagIcon from '../../icons/TagIcon';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from "@material-ui/core/ListItemText";
import icons_bn from '../../other/icons_bn.json';
import Grid from "@material-ui/core/Grid";
import { Typography } from '@material-ui/core';
import CloseIcon from '../../icons/CloseIcon16';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import utils from '../../other/utils';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},

	paper: {
		marginRight: theme.spacing(2),
		zIndex: 1,
	},

	TagsSum: {
		paddingLeft: 8,
		fontSize: '13px',
		lineHeight: '16px',

		[theme.breakpoints.down(1702)]: {
			display: 'none'
		}
	},

	rootList: {
		display: 'flex',
		// justifyContent: 'center',
		flexWrap: 'wrap',
		listStyle: 'none',
		color: '#F00',
		justifyContent: 'start',
		padding: '0 12px',
	},

	chip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		// backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#8987A2',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},
	},

	li: {
		margin: '0 3.5px',

		'&:first-child': {
			marginLeft: 0
		},

		'&:last-child': {
			marginRight: 0
		},
	},
}));

const StyledMenuItem = withStyles((theme) => ({
	root: {
		padding: "0 24px",
		// minWidth: 293,
		color: "#FFFFFF",
		minHeight: 40,
		"&:hover": {
			backgroundColor: "#F6F6FB",
		},
		// "&:focus": {
		//backgroundColor: theme.palette.primary.main,
		// "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
		"& .MuiListItemText-primary": {
			// width: 213,
			fontFamily: 'Cera CY',
			fontStyle: 'normal',
			fontWeight: 'normal',
			fontSize: '16px',
			lineHeight: '24px',
			// color: '#24262A',
			marginLeft: 8,
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			width: 260
		}
		// }
	}
}))(MenuItem);

const StyledButton = withStyles({
	root: {
		background: '#F6F6FB',
		borderRadius: 16,
		border: 0,
		// color: 'white',
		// height: 48,
		padding: '0 8px',
		// boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
		height: 24,
		minWidth: 32
	},
	label: {
		textTransform: 'capitalize',
	},
})(Button);

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

export default function AppCardTagList(props) {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef(null);
	let { tagsQ , codeasvul} = props;

	const handleClick = (event) => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		}
	}

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = React.useRef(open);
	React.useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = open;
	}, [open]);

	const chechActiveTags = (id) => {
		if (props.arrayTag) {
			return props.arrayTag.some(el => +el.key === +id)
		}
	}

	function AdditionalView(data, label) {
		if (props.arrayTag.some(el => +el.key === +data)) {
			props.setArrayTag([...props.arrayTag.filter(el => +el.key !== +data)]);
		} else {
			props.setArrayTag(props.arrayTag.concat([{ key: +data, label: label }]))
		}
	}

	function checkTag(el0, el1) {
		if (window.location.pathname.indexOf("/applications/apptags") > -1) {
			AdditionalView(el1.trim(), el0.trim())
		} else if (!chechActiveTags(el1.trim())) {
			//localStorage.setItem('cartApp123','233')
			utils.setDataToStorage('AppsArrayTag', JSON.stringify([{ key: +el1, label: el0 }]))
			window.open("/applications/apptags")
			//AdditionalView(el1.trim(), el0.trim())
		} else {
			AdditionalView(el1.trim(), el0.trim())
		}
	}

	function AppCardTagList() {
		return (
			<Grid
				item
				lg={12} md={12} sm={12}
				component="ul"
				className={classes.rootList}
				style={{ alignItems: 'center' }}
			>
				{props.icon === true
					?
					<Grid item style={{ height: 16, width: 16, marginRight: 4 }}>
						<TagIcon fill='#BCBBD0' />
					</Grid>
					:
					''
				}

				{tagsQ.split(', ').map(elem => {
					let elemM = elem.split('#;')
					return (
						<li key={elemM[0].trim() + elemM[1].trim()} className={classes.li}>
							<Chip key={'_tags' + elemM[1].trim()}
								onClick={() => checkTag(elemM[0], elemM[1])}
								label={elemM[0].trim()}
								className={classes.chip}
								style={{ color: !chechActiveTags(elemM[1].trim()) ? '#8987A2' : '#FFF', backgroundColor: !chechActiveTags(elemM[1].trim()) ? '#F6F6FB' : '#EB505E' }}
							/>
						</li>
					);
				})}
			</Grid>
		);
	}

	return (
		<div className={classes.root}>
			{props.card === true
				?
				AppCardTagList()
				:
				<React.Fragment>
					<StyledButton
						className='tagArrBtn'
						aria-label="more"
						ref={anchorRef}
						aria-controls={open ? 'menu-list-grow' : undefined}
						aria-haspopup="true"
						size="small"
						onClick={(e) => handleClick(e)}
					>
						<TagIcon fill='#BCBBD0' />
						{
							props.view !== 'tbl'
								?
								<Typography tagsCodeasvul = {codeasvul} tagsControl='1' allTags = {tagsQ} style={{ paddingLeft: 8, fontSize: '13px', lineHeight: '16px' }}>Теги <span style={{ color: '#8987A2' }}>({tagsQ.split(', ').length})</span></Typography>
								:
								<Typography   className={classes.TagsSum}>{tagsQ.split(', ').length}</Typography>
						}
					</StyledButton>

					<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal placement={'bottom-start'} style={{ zIndex: 1 }}>
						{({ TransitionProps, placement }) => (
							<Grow
								{...TransitionProps}
								style={{ transformOrigin: placement === 'bottom' ? 'left bottom' : 'left top' }}
							>
								<Paper style={{
									maxHeight: 280,
									minWidth: 360,
									maxWidth: 360,
									boxShadow: '4px 4px 30px rgba(35, 72, 152, 0.2)',
									borderRadius: '16px',
									paddingTop: '8px',
									paddingBottom: '8px', overflow: 'auto'
								}}>
									<Grid container style={{ paddingLeft: 24, fontSize: '18px', lineHeight: '28px', color: '#24262A' }}>
										<Typography style={{ fontSize: '18px', lineHeight: '28px', color: '#24262A', fontWeight: 500 }}>Список тегов <span style={{ color: '#8987A2' }}>({tagsQ.split(', ').length})</span></Typography>
									</Grid>

									<ClickAwayListener onClickAway={handleClose}>
										<MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown} style={{ maxHeight: 236, overflow: 'auto' }}>
											{tagsQ.length > 0
												?
												tagsQ.split(', ').sort().map(elem => {
													let elemM = elem.split('#;')

													return (
														!chechActiveTags(elemM[1].trim())
															?
															<StyledMenuItem /* onClick={() => console.log(tagsQ, elemM)} */ onClick={() => checkTag(elemM[0], elemM[1])}>
																<TagIcon fill={"#24262A"} />
																{
																	elemM[0].trim().length > 15
																		?
																		<CustomTooltip title={elemM[0].trim()}>
																			<ListItemText style={{ color: '#24262A' }} primary={elemM[0].trim()} />
																		</CustomTooltip>
																		:
																		<ListItemText style={{ color: '#24262A' }} primary={elemM[0].trim()} />
																}
															</StyledMenuItem>
															:
															<StyledMenuItem /* onClick={() => console.log(tagsQ, elemM)} */ onClick={() => checkTag(elemM[0], elemM[1])}>
																<CloseIcon fill={"#24262A"} />

																{
																	elemM[0].trim().length > 15
																		?
																		<CustomTooltip title={elemM[0].trim()}>
																			<ListItemText style={{ color: '#BCBBD0' }} primary={elemM[0].trim()} />
																		</CustomTooltip>
																		:
																		<ListItemText style={{ color: '#BCBBD0' }} primary={elemM[0].trim()} />
																}
															</StyledMenuItem>
													)
												})
												:
												''
											}
										</MenuList>
									</ClickAwayListener>
								</Paper>
							</Grow>
						)}
					</Popper>
				</React.Fragment>
			}
		</div>
	);
}